export const GLOBAL_SEARCH_INPUT_STATE_UPDATE = 'GLOBAL_SEARCH_INPUT_STATE_UPDATE';
